module.exports = __webpack_public_path__ + "static/media/app-store.922fa1d1.svg";